export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const API_BASE_IMG_URL = process.env.REACT_APP_BASE_IMG_URL || '';
export const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL || '';
